module.exports = __webpack_public_path__ + "img/fangxinlogo.c91ad346.png";